<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation style="max-width: 70rem;
      width: 100%;
      margin: auto;max-width: 50rem;">
      <v-card-text>
        <v-container>
          <v-card elevation="7" style="padding: .5rem;">
            <v-card-title>
              <span class="text-h5" style="color: rgb(0 108 187); font-weight: 600;">Inscripción a la Escuela de
                Cuidadores del Paciente en Diálisis - EsSalud</span>
            </v-card-title>
          </v-card>
          <v-card elevation="7" style="padding:3rem 2rem; margin-top: 1rem;">
            <h4 style="color: rgb(0 108 187);">Datos del paciente</h4>
            <v-divider style="margin-bottom: 2rem;"></v-divider>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.num_docPaciente" label="Ingrese DNI del paciente*"
                  :maxlength="maxdat" @keyup.enter="loadPaciente" required
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"></v-text-field>
                <!-- <v-btn @click="loadPaciente">Buscar</v-btn> -->
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.nombre" label="Nombre y apellidos" :maxlength="maxdat"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.ipress" :items="itemsIpress" dense item-text="descripCas"
                  item-value="url" label="Clínica actual" :maxlength="90" disabled></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.distrito" :items="itemsDistrito" dense item-text="distrito"
                  item-value="url" label="Distrito actual" :maxlength="90" disabled></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono" label="Teléfono" :maxlength="maxdat"
                  :disabled="statusTelefono"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono_paciente" label="Añadir otro teléfono"></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-card elevation="7" style="padding:3rem 2rem;margin-top: 1rem;">
            <h4 style="    color: rgb(0 108 187);">Registro importante</h4>
            <v-divider style="margin-bottom: 2rem;"></v-divider>
            <h4 style="    color: rgb(0 108 187);">¿Desea registrar a un cuidador?, hasta el momento lleva registrado(s)
              {{ numeroCuidadores }} cuidador(es)*</h4>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="d-flex">
                <v-checkbox v-model="titularSi" :label="`Sí`" style="margin-right: 1rem;"
                  @click="updateEstado('titularSi')"></v-checkbox>
                <v-checkbox v-model="titularNo" :label="`No`" @click="updateEstado('titularNo')"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="titularNo">
                <v-text-field v-model="dataSolicitud.dni_cuidador" label="DNI*" :maxlength="maxdat"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="titularNo">
                <v-text-field v-model="dataSolicitud.nombre_cuidador" label="Nombre*" :maxlength="maxdat"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="titularNo">
                <v-text-field v-model="dataSolicitud.correo_cuidador" label="Correo*" :maxlength="maxdat"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="titularNo">
                <v-text-field v-model="dataSolicitud.telefono_cuidador" label="Teléfono*" :maxlength="maxdat"
                  required></v-text-field>
              </v-col>
            </v-row>
            <br>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="d-flex">
                <v-checkbox v-model="dataSolicitud.certificado" style="margin-right: 1rem;"></v-checkbox>
                <h4 style="color:rgb(0 108 187); display: flex; align-items: center;">¿Desea certificado?*</h4>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-card style="padding: 1rem;">
                  <h4 style="color: rgb(0 108 187);">Nota: La información será contrastada antes de realizar la
                    inscripción*</h4>
                </v-card>
              </v-col>
              <v-card-actions style="margin-top: 1rem;">
                <v-spacer></v-spacer>
                <v-btn text @click="validarCampos" v-if="!statusFormEdit"> Grabar </v-btn>
                <v-btn text @click="validarCampos" v-if="statusFormEdit"> Editar </v-btn>
              </v-card-actions>
            </v-row>
          </v-card>
        </v-container>
      </v-card-text>
    </v-form>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
      <v-card color="#1973a5" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.swal2-shown.swal2-height-auto {
  padding: 0 !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import "jspdf-autotable";
import Swal from "sweetalert2";
import jsPDF from "jspdf";

export default {
  props: ['itemsSend'],
  data: () => ({
    statusFormEdit: false,
    dialogLoader: false,
    //Perfil Usuario
    perfil: "",
    nombre: "",
    url: "",
    usuario: "",
    //Distritos
    itemsDistrito: [],
    //IPRESS
    itemsIpress: [],
    //Paciente
    dataPaciente: [],
    //Datos Formulario
    dataSolicitud: {
      paciente_id: null,
      num_docPaciente: null,
      nombre: null,
      ipress: null,
      distrito: null,
      telefono: null,
      telefono_cuidador: null,
      telefono_paciente: null,
      documento_cuidador: null,
      nombre_cuidador: null,
      correo_cuidador: null,
      certificado: false,
      cuidador_estado: false,
      fecha_registro: `${new Date().toLocaleDateString('sv-SE')} ${new Date().toLocaleTimeString('sv-SE', { hour12: false })}`
    },
    //Formulario Parámetros
    titularSi: true,
    titularNo: false,
    valid: true,
    maxdatDocumento: 20,
    maxdat: 50,
    stateOtro: false,
    statusOtroParentesco: false,
    statusCertificado: false,
    rules: {
      required: (value) => !!value || "Campo Obligatorio.",
      counter: (value) => value <= 20 || "Max 20 characters",
    },
    statusTelefono: true,
    numeroCuidadores: 0
  }),

  computed: {},
  watch: {
    titularSi(newValue) {
      // Si titularSi está marcado como "Sí", deselecciona titularNo
      if (newValue) {
        this.titularNo = false;
      }
    },
    titularNo(newValue) {
      // Si titularNo está marcado como "No", deselecciona titularSi
      if (newValue) {
        this.titularSi = false;
      }
    }
  },
  methods: {
    updateEstado(selectedCheckbox) {
      if (selectedCheckbox === 'titularSi' && !this.titularSi) {
        this.titularNo = true;
      } else if (selectedCheckbox === 'titularNo' && !this.titularNo) {
        this.titularSi = true;
      }
    },
    validarCampos() {
      this.dialogLoader = true;
      if (this.dataSolicitud.num_docPaciente == null) {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        this.dialogLoader = false;
        return;
      };
      if (this.titularSi == false && (this.dataSolicitud.dni_cuidador == null || this.dataSolicitud.nombre_cuidador == null || this.dataSolicitud.correo_cuidador == null || this.dataSolicitud.telefono_cuidador == null)) {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        this.dialogLoader = false;
      } else {
        this.grabar();
      };
    },
    grabar() {
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/formularioCapacitacion/",
              this.dataSolicitud,
              {
                headers: { Authorization: this.auth },
              })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Exito!",
                text: "¡Usted se registró correctamente!",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
              window.location.reload();
            })
            .catch((res) => {
              console.log("Error:", res);
              this.dialogLoader = false;
              Swal.fire({
                title: "Error!",
                text: "¡No registró correctamente!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadIpress() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.itemsIpress = res.data.filter(item => item.estado === true);

              this.loadDistritos();
            })
            .catch((res) => {
              console.log("Error:", res);
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadDistritos() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              const dataDistrito = res.data.filter(item => item.estado === true);
              /* this.itemsDistrito = dataDistrito.filter(item => item.distrito !== "1"); */
              this.itemsDistrito = dataDistrito
                .filter(item => item.estado == true && item.tipoCas !== "1")
                .sort((a, b) => a.distrito.localeCompare(b.distrito));

              // Suponiendo que tu array original se llama 'data'
              let distritosUnicos = [];
              let distritosYaVistos = {};

              for (let i = 0; i < this.itemsDistrito.length; i++) {
                let distrito = this.itemsDistrito[i].distrito;
                if (!distritosYaVistos[distrito]) {
                  distritosUnicos.push(this.itemsDistrito[i]);
                  distritosYaVistos[distrito] = true;
                }
              }
              this.itemsDistrito = distritosUnicos;
              this.itemsDistrito1 = distritosUnicos;
              this.itemsDistrito2 = distritosUnicos;
              console.log("se lista los distritos en su totatl", this.itemsDistrito);
              if (this.usuario && this.itemsSend) {
                this.editCreate();
                this.statusFormEdit = true;
              }
            })
            .catch((res) => {
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    /* loadPaciente() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/asigCuposPac/?search="+this.dataSolicitud.num_docPaciente+",true", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              
              this.dataPaciente = res.data;
              if(this.dataPaciente[0]){
                this.dataSolicitud.paciente_id=this.dataPaciente[0].datosPaciente.url;
                this.dataSolicitud.nombre=this.dataPaciente[0].datosPaciente.nombre_completo;
                this.dataSolicitud.ipress=this.dataPaciente[0].datosPueto.datosCas.url;
                this.dataSolicitud.distrito=this.dataPaciente[0].datosPueto.datosCas.url;
                if(!this.dataPaciente[0].telefono&& this.dataPaciente[0].datosPaciente.telefono_paciente){
                    this.dataSolicitud.telefono=this.dataPaciente[0].datosPaciente.telefono_paciente;
                    this.dataSolicitud.telefono_paciente=this.dataPaciente[0].datosPaciente.telefono;
                }else{
                    this.dataSolicitud.telefono=this.dataPaciente[0].datosPaciente.telefono;
                    this.dataSolicitud.telefono_paciente=this.dataPaciente[0].datosPaciente.telefono_paciente;
                }
                this.statusTelefono=this.dataPaciente[0].datosPaciente.telefono==null?false:true;
                this.loadCuidadores(this.dataPaciente[0].datosPaciente.url);
              }else{
                this.dataSolicitud.paciente_id="";
                this.dataSolicitud.nombre="";
                this.dataSolicitud.ipress="";
                this.dataSolicitud.distrito="";
                this.dataSolicitud.telefono="";
                this.dataSolicitud.telefono_paciente="";
                this.numeroCuidadores=0;
                Swal.fire({
                title: "¡Error!",
                text: "¡El DNI ingresado no corresponde al de un paciente inscrito!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
              }
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    }, */
    loadPaciente() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_busqueda_pacientes/", { dni: this.dataSolicitud.num_docPaciente }, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {

              this.dataPaciente = res.data;
              if (this.dataPaciente[0]) {
                this.dataSolicitud.paciente_id = this.dataPaciente[0].datosPaciente.url;
                this.dataSolicitud.nombre = this.dataPaciente[0].datosPaciente.nombre_completo;
                this.dataSolicitud.ipress = this.dataPaciente[0].datosPueto.datosCas.url;
                this.dataSolicitud.distrito = this.dataPaciente[0].datosPueto.datosCas.url;
                if (!this.dataPaciente[0].telefono && this.dataPaciente[0].datosPaciente.telefono_paciente) {
                  this.dataSolicitud.telefono = this.dataPaciente[0].datosPaciente.telefono_paciente;
                  this.dataSolicitud.telefono_paciente = this.dataPaciente[0].datosPaciente.telefono;
                } else {
                  this.dataSolicitud.telefono = this.dataPaciente[0].datosPaciente.telefono;
                  this.dataSolicitud.telefono_paciente = this.dataPaciente[0].datosPaciente.telefono_paciente;
                }
                this.statusTelefono = this.dataPaciente[0].datosPaciente.telefono == null ? false : true;
                this.loadCuidadores(this.dataPaciente[0].datosPaciente.url);
              } else {
                this.dataSolicitud.paciente_id = "";
                this.dataSolicitud.nombre = "";
                this.dataSolicitud.ipress = "";
                this.dataSolicitud.distrito = "";
                this.dataSolicitud.telefono = "";
                this.dataSolicitud.telefono_paciente = "";
                this.numeroCuidadores = 0;
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El DNI ingresado no corresponde al de un paciente inscrito!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
              }
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadCuidadores(idPaciente) {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_calculo_numero_cuidadores/", { paciente: idPaciente.split("/")[4] }, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.numeroCuidadores = res.data[0].n;

            })
            .catch((res) => {
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    }
  },

  mounted() {
  },
  created() {
    this.loadIpress();
    this.usuario = sessionStorage.getItem("usuario");
  },
};
</script>